import "@scss/main.scss";
import "picturefill";
import "lazysizes";
import { setupAllScroll } from "@js/modules/scroll";
import { setupAllHamburgerMenu } from "@js/modules/hamburger";
import { setupAllMenu } from "@js/modules/menu";
import { setupAllLazyloading } from "@js/modules/lazyload";
import { setupAllDomainSpecificLogic } from "@js/modules/domain";
import { setupAllCarousel } from "@js/modules/carousel";
import { setupAllModals } from "@js/modules/modal";
import { makeBrowserDetector } from "@js/libs/BrowserDetector";
import { setupAllAccordino } from "@js/modules/accordino";
import { setupAllClickDelegates } from "@js/modules/clickDelegate";
import { setupAllFormValidation } from "@js/modules/formValidation";
import { setupTopBanner } from "@js/modules/topBanner";
import TableOfContentsBlock from "@js/modules/TableOfContentsBlock";
// import { setupAllFavorites } from "./modules/favorites";

// register CSS classes on <html> to help with browser detection in CSS
const B = makeBrowserDetector(window).bootstrapClasses();


document.addEventListener("DOMContentLoaded", function(){
	const pixelsFromTop = 40; // pixels to scroll before meaning "yeah, we scrolled"
	setupAllDomainSpecificLogic();
	setupTopBanner();
	setupAllHamburgerMenu();
	setupAllMenu();
	setupAllLazyloading();
	setupAllCarousel();
	setupAllModals();
	setupAllAccordino();
	setupAllScroll(pixelsFromTop);
	setupAllClickDelegates();
	setupAllFormValidation();
	// setupAllFavorites();

	if(document.querySelector(".o-block_toc")){
		const toc = new TableOfContentsBlock(document.querySelector(".o-block_toc"));
		toc.init();
		toc.initDesktop();
	}

	// Cookiebot
	const opener = document.querySelector("a[href='#cookies']");
	if(opener && typeof Cookiebot !== "undefined"){
		opener.addEventListener("click", e => {
			e.preventDefault();
			window.Cookiebot.renew();
		});
	}
});

// SWPL LOG
console.log(
	"%c S W P L ",
	`background: #1467ff;
	color: white;
	font-size: 17px;
	font-weight: bold;
	line-height: 36px; text-align: center`,
	" www.swpl.fr"
);
